import type { Error } from '../types';
import { CONTAIN_NUMBER_REGEXP } from '../utils/regex';

export const mustNotContainNumber =
  (message?: Error['message'], allowEmpty = false) =>
  (value: string): Error => {
    const valid = !!value && !CONTAIN_NUMBER_REGEXP.test(value);
    return {
      valid: allowEmpty ? !value || valid : valid,
      message
    };
  };
